import { useMemo, useState, useEffect } from "react";
import { Button, Box, Modal, useMediaQuery } from "@mui/material";
import Logo from "../Logo/Logo";
import SignIn from "../../single/SignIn/SignIn";
import PropTypes from "prop-types";
import styles from "./HeaderMain.module.css";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";

const HeaderMain = ({ className = "", headerMainPageOverflow }) => {
  const [open, setOpen] = useState(false);
  const [redirectPath, setRedirectPath] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();

  const handleOpen = (path) => {
    if (!isAuthenticated) {
      setRedirectPath(path);
      setOpen(true);
    } else {
      navigate("/dashboard")
    }
  };

  const handleClose = () => setOpen(false);

  const handleSignInSuccess = () => {
    setOpen(false);
    if (redirectPath === "create") {
      window.location.href = "/create";
    } else if (redirectPath === "signIn") {
      window.location.href = "/dashboard";
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const { exp } = jwtDecode(token);
        if (exp && exp * 1000 > Date.now()) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (err) {
        Sentry.captureException(err);
        setIsAuthenticated(false);
      }
    }
  }, []);

  const headerMainPageStyle = useMemo(() => {
    return {
      overflow: headerMainPageOverflow,
    };
  }, [headerMainPageOverflow]);

  return (
    <header
      className={[styles.headermainpage, className].join(" ")}
      style={headerMainPageStyle}
    >
      <Logo 
        group="/group.svg" 
        group1="/group-1.svg" 
        onLogo2ContainerClick={() => window.location.href = "/"}
        style={{ cursor: "pointer" }}
      />
      <Box className={styles.buttonsLabelFilledRestParent}>
        {/* <Button
          className={styles.buttonsLabelFilledRest}
          disableElevation
          variant="contained"
          onClick={() => handleOpen("create")}
          sx={{
            textTransform: "none",
            color: "#fff",
            fontSize: "14",
            background: "#ff9500",
            borderRadius: "23px",
            "&:hover": { background: "#ff9500" },
            width: 98,
            height: 40,
          }}
        >
          Create
        </Button> */}

        {isAuthenticated ? (
          <Button
            className={styles.buttonsLabelFilledRest}
            disableElevation
            variant="contained"
            onClick={() => navigate("/dashboard")}
            sx={{
              textTransform: "none",
              color: "#000",
              fontSize: "14",
              background: "#fff",
              borderColor: "#ff9500",
              borderWidth: "1px",
              borderStyle: "solid",
              borderRadius: "23px",
              "&:hover": { background: "#fff" },
              width: 98,
              height: 40,
            }}
          >
            Dashboard
          </Button>
        ) : (
          <Button
            className={styles.buttonsLabelFilledRest}
            disableElevation
            variant="contained"
            onClick={() => handleOpen("signIn")}
            sx={{
              textTransform: "none",
              color: "#000",
              fontSize: "14",
              background: "#fff",
              borderColor: "#ff9500",
              borderWidth: "1px",
              borderStyle: "solid",
              borderRadius: "23px",
              "&:hover": { background: "#fff" },
              width: 98,
              height: 40,
            }}
          >
            Sign In
          </Button>
        )}
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box className={styles.signInModal}>
          <SignIn onSignInSuccess={handleSignInSuccess} onClose={handleClose} create={redirectPath === "create"}/>
        </Box>
      </Modal>
    </header>
  );
};

HeaderMain.propTypes = {
  className: PropTypes.string,
  headerMainPageOverflow: PropTypes.string,
};

export default HeaderMain;